import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  Cell,
  LabelList,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

const data = [
  {
    name: "TAX",
    value: 30,
  },
  {
    name: "Selling Exp",
    value: 5,
  },
  {
    name: "Admin Exp",
    value: 4,
  },
  {
    name: "Depreciation & Amortization",
    value: 0,
  },
  {
    name: "Operating Exp",
    value: 61,
  },
  {
    name: "Interest Incurred",
    value: 0,
  },
  {
    name: "Dividends",
    value: 0,
  },
  {
    name: "Other Opex",
    value: 0,
  },
];

const getVal = (str) => {
  return data.find((obj) => obj.name === str).value;
};

const ExpenseChart = () => {
  const COLORS = [
    "#DC2023",
    "#3E3E3E",
    "#FF6D6A",
    "#FF6D6A",
    "#D3D3D3",
    "#D3D3D3",
    "#D3D3D3",
    "#D3D3D3",
  ];

  return (
    <>
      <Row>
        <Col md={7}>
          <ResponsiveContainer width="100%" height={400}>
            <PieChart width={730} height={300}>
              <Pie
                stroke="none"
                data={data}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
              >
                {data.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </Col>
        <Col md={5}>
          <div className="flex-wrap-items align-items-center pb-4">
            <div className="color-sector red-sector "></div>
            <p className="para">
              TAX <br /> {getVal("TAX")}%
            </p>
          </div>
          <div className="flex-wrap-items align-items-center pb-4">
            <div className="color-sector dark-sector"></div>
            <p className="para">
              Selling Exp <br /> {getVal("Selling Exp")}%
            </p>
          </div>
          <div className="flex-wrap-items align-items-start pb-4">
            <div className="color-sector  pink-sector"></div>
            <p className="para">
              Admin Exp <br /> {getVal("Admin Exp")}% <br />
              Depreciation & Amortization
              <br /> {getVal("Depreciation & Amortization")}%
            </p>
          </div>
          <div className="flex-wrap-items align-items-start pb-4">
            <div className="color-sector gray-sector"></div>
            <p className="para">
              Operating Exp <br /> {getVal("Operating Exp")}% <br />
              Interest Incurred <br /> {getVal("Interest Incurred")}% <br />
              Dividends <br /> {getVal("Dividends")}% <br />
              Other OPEX <br /> {getVal("Other Opex")}% <br />
            </p>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ExpenseChart;
